import React from 'react';

export const MainContext = React.createContext({
    MIN_EXPANDED_WIDTH: 1300,
    sidebarOpen: true,
    headerTitle: '',
    loggedUser: {},
    servicesRunning: 0,
    openSidebar: () => {
    },
    closeSidebar: () => {
    },
    setHeaderTitle: title => {
    },
    addServiceRunning: () => {
    },
    removeServiceRunning: () => {
    },
});